import { useEffect, memo } from 'react'

import { getTranslate, lang } from '../../localization'

interface PageHeaderProps {
  title: string | undefined
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
  useEffect(() => {
    if (title) {
      if (lang === 'en') {
        document.title = title + ' | ' + getTranslate('Adotel')
      } else {
        document.title = getTranslate('Adotel') + ' | ' + title
      }
    }
  }, [title])

  return null
}

export default memo(PageHeader)
